"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
var core_1 = require("@apollo/client/core");
var graphql_1 = require("graphql");
var ActionCableLink = /*#__PURE__*/function (_core_1$ApolloLink) {
  function ActionCableLink(options) {
    var _this;
    _classCallCheck(this, ActionCableLink);
    _this = _callSuper(this, ActionCableLink);
    _this.cable = options.cable;
    _this.channelName = options.channelName || "GraphqlChannel";
    _this.actionName = options.actionName || "execute";
    _this.connectionParams = options.connectionParams || {};
    return _this;
  }
  // Interestingly, this link does _not_ call through to `next` because
  // instead, it sends the request to ActionCable.
  _inherits(ActionCableLink, _core_1$ApolloLink);
  return _createClass(ActionCableLink, [{
    key: "request",
    value: function request(operation, _next) {
      var _this2 = this;
      return new core_1.Observable(function (observer) {
        var channelId = Math.round(Date.now() + Math.random() * 100000).toString(16);
        var actionName = _this2.actionName;
        var connectionParams = typeof _this2.connectionParams === "function" ? _this2.connectionParams(operation) : _this2.connectionParams;
        var channel = _this2.cable.subscriptions.create(Object.assign({}, {
          channel: _this2.channelName,
          channelId: channelId
        }, connectionParams), {
          connected: function connected() {
            this.perform(actionName, {
              query: operation.query ? (0, graphql_1.print)(operation.query) : null,
              variables: operation.variables,
              // This is added for persisted operation support:
              operationId: operation.operationId,
              operationName: operation.operationName
            });
          },
          received: function received(payload) {
            var _a, _b;
            if (((_a = payload === null || payload === void 0 ? void 0 : payload.result) === null || _a === void 0 ? void 0 : _a.data) || ((_b = payload === null || payload === void 0 ? void 0 : payload.result) === null || _b === void 0 ? void 0 : _b.errors)) {
              observer.next(payload.result);
            }
            if (!payload.more) {
              observer.complete();
            }
          }
        });
        // Make the ActionCable subscription behave like an Apollo subscription
        return Object.assign(channel, {
          closed: false
        });
      });
    }
  }]);
}(core_1.ApolloLink);
exports["default"] = ActionCableLink;